export enum CookieKeyEnum {
  user = 'b2b-portal-current-user',
  token = 'b2b-portal-token',
}
